<template>
  <div class="question-card">
    <div class="question-title">
      <!-- <div class="question-type">{{ TypeCNMap[info.type] }}</div> -->
      <div class="question-stem">
        {{ info?.respone?.displayNo }}.
        <div v-html="info.content.stem"></div>
      </div>
    </div>
    <div class="question-options">
      <div
        v-for="option in options"
        :key="option.id"
        class="question-options-item-wrapper"
      >
        <div class="radio" :class="option.status"></div>
        <div class="question-option-item">
          <div>{{ option.id }}.</div>
          <div v-html="option.description"></div>
        </div>
      </div>
    </div>
    <div class="question-parse">
      <div class="answer">
        答案是 <span class="true">{{ info.key }}</span> ，您选的是
        <span :class="info.respone.score === info.point ? 'true' : 'false'">{{
          info.respone.singleResult
        }}</span>
      </div>
      <div class="score">
        <span :class="info.respone.score === info.point ? 'true' : 'false'"
          >得{{ info.respone.score }}分
        </span>
        <span class="true">共{{ info.point }}分</span>
      </div>
    </div>
    <div
      class="question-analysis"
      v-html="info.analysis"
      v-if="visiableAnalysis && info.analysis"
    ></div>
  </div>
</template>
<script setup>
import cloneDeep from "lodash/cloneDeep";

import { ref, reactive, computed } from "vue";
const TypeCNMap = {
  mc: "多选",
  sc: "单选",
  tf: "判断",
};
const props = defineProps({
  info: Object,
  visiableAnalysis: Boolean,
});
const options = computed(() => {
  const { content, respone, key } = cloneDeep(props.info);
  const parsedOptions = content.options.map((item) => {
    item.status = "NONE";
    if (key.includes(item.id)) item.status = "RIGHT";
    if (!key.includes(item.id) && respone.singleResult.includes(item.id)) {
      item.status = "WRONG";
    }

    return item;
  });

  return parsedOptions;
});
</script>
<style scoped lang="scss">
.question-card {
  width: 100%;
  padding: 27px 38px 38px;
  box-sizing: border-box;
  background: #fff;
  margin-bottom: 10px;
  .question-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    .question-type {
      width: 65px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      background: #43b7ff;
      border-radius: 6px 6px 6px 0px;
      font-size: 19px;
      color: #ffffff;
    }
    .question-stem {
      flex: 1;
      display: flex;
      font-size: 27px;
      line-height: 38px;
      font-weight: 500;
      color: #36426c;
      letter-spacing: 0.5px;
      word-wrap: break-word;
    }
  }
  .question-options {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    margin-top: 28px;
    padding: 0 10px;
    .question-options-item-wrapper {
      display: flex;
      align-items: flex-start;
      gap: 38px;
    }
  }
  .question-option-item {
    display: flex;
    font-size: 27px;
    color: #1c264f;
    line-height: 38px;
    column-gap: 18px;
  }
}
.radio {
  width: 38px;
  height: 38px;
  background: #ffffff;
  border: 2px solid #717790;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
  margin-top: -3px;
  &.RIGHT {
    border: 2px solid #60b837;

    &::after {
      content: "";
      position: absolute;
      top: 6px;
      left: 6px;
      background: #60b837;
      width: 26px;
      height: 26px;
      border-radius: 50%;
    }
  }
  &.WRONG {
    @extend .RIGHT;

    border: 2px solid #d10000;

    &::after {
      @extend .RIGHT::after;

      background: #d10000;
    }
  }
}
.question-parse {
  display: flex;
  margin-top: 30px;
  padding: 0 19px;
  height: 69px;
  background: #f6f6f9;
  font-size: 27px;
  color: #1c264f;
  line-height: 69px;
  justify-content: space-between;
  .true {
    color: #60b837;
  }
  .false {
    color: #d10000;
  }
}
:deep(.question-analysis) {
  overflow-x: auto;
  margin-top: 15px;
  padding: 20px;
  background: #f6f6f9;
  font-size: 26px;
  color: #1c264f;
  line-height: 69px;
  justify-content: space-between;
  line-height: 36px;

  ol,
  li {
    list-style: none !important;
  }
}
</style>
